import CategorySEO from './CategorySEO';

export default CategorySEO;
